export const TExcelManagementActionType = {
  UploadExcel: 'UPLOAD_EXCEL' as const,
  UploadExcelSuccess: 'UPLOAD_EXCEL_SUCCESS' as const,
  UploadExcelFailure: 'UPLOAD_EXCEL_FAILURE' as const,
  DownloadExcel: 'DOWNLOAD_EXCEL' as const,
  DownloadExcelSuccess: 'DOWNLOAD_EXCEL_SUCCESS' as const,
  DownloadExcelFailure: 'DOWNLOAD_EXCEL_FAILURE' as const,
  DownloadErrorExcel: 'DOWNLOAD_ERROR_EXCEL' as const,
  DownloadExcelErrorSuccess: 'DOWNLOAD_ERROR_EXCEL_SUCCESS' as const,
  DownloadExcelErrorFailure: 'DOWNLOAD_ERROR_EXCEL_FAILURE' as const,
  DownloadListingDataExcel: 'DOWNLOAD_LISTING_DATA_EXCEL' as const,
  DownloadListingDataExcelSuccess: 'DOWNLOAD_LISTING_DATA_EXCEL_SUCCESS' as const,
  DownloadListingDataExcelFailure: 'DOWNLOAD_LISTING_DATA_EXCEL_FAILURE' as const,
};
